import { connect } from 'react-redux';
import { removeNotificationFromQueue } from '../redux/actionCreators';
import { getNotificationQueue } from '../redux/selectors';
var mapStateToProps = function (state, _a) {
    var queueName = _a.queueName;
    return ({
        notifications: getNotificationQueue(state, queueName),
    });
};
var mapDispatchToProps = {
    removeNotification: removeNotificationFromQueue,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CustomNotificationContext.container.js.map